import { Vector3 } from 'three';
import Representation2d from './Representation2d';
import ShapeTypeEnum from './ShapeTypeEnum';

export default class LineloopsRepresentation2d extends Representation2d {
    
    lineloops: Vector3[][] = [];
    fills: Vector3[][] = [];

    constructor(lineloops: Vector3[][], fills: Vector3[][] = [], materialId: number | null) {
        super(ShapeTypeEnum.Lineloops, materialId);
        this.lineloops = lineloops;
        this.fills = fills;
    }
    
    
}